import { permissionService } from '@/services/permission.service'
import { VNode } from 'vue'
// eslint-disable-next-line import/no-unresolved
import { DirectiveBinding } from 'vue/types/options'

function handleDirective(element: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
  if (!binding.value) {
    return
  }

  // If user dont has permission, create a comment in place of the element
  if (!permissionService.hasPermission(binding.value)) {
    const comment = document.createComment('')
    Object.defineProperty(comment, 'setAttribute', {
      value: () => undefined,
    })
    vnode.elm = comment
    vnode.text = ' '
    vnode.isComment = true
    vnode.context = undefined
    vnode.tag = undefined
    vnode.data!.directives = undefined

    if (vnode.componentInstance) {
      // @ts-ignore
      vnode.componentInstance.$el = comment
    }

    if (element.parentNode) {
      element.parentNode.replaceChild(comment, element)
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export const permissionDirective = {
  inserted: handleDirective,
  update: handleDirective,
}
